export const tiposConta = [{
  name: 'Conta Corrente',
  value: 'ContaCorrente'
}, {
  name: 'Conta Poupança',
  value: 'ContaPoupanca'
}];



// WEBPACK FOOTER //
// ./src/app/shared/services/conta/tipos-conta.service.ts